import React from "react"
import { Col, Row } from "react-bootstrap"
import Section from "../../components/Section"
import TextAreaField from "../../components/Field/TextArea"
import { ReferenceDataType, withReferenceDataState } from "../../globalStates/ReferenceDataHOC"
import LanguageSwitch from "../languageSwitch"
import branding from "../../branding/branding"

interface DescriptionProps {
    baseId: string
    title: string
    labelLongdescription: string
    labelShortdescription: string
    placeholderLongdescription: string
    placeholderShortdescription: string
    valueLongDescription: string | undefined
    valueShortDescription: string | undefined
    language: string
    validateShortDescription?: () => string[]
    validateLongDescription?: () => string[]
    onChangeLongDescription: (event: React.ChangeEvent<HTMLInputElement>) => void
    onChangeShortDescription: (event: React.ChangeEvent<HTMLInputElement>) => void
    onChangeLanguage: (language: string) => void
}

const Description: React.FC<DescriptionProps & ReferenceDataType> = ({
    baseId,
    title,
    labelLongdescription,
    labelShortdescription,
    placeholderLongdescription,
    placeholderShortdescription,
    valueLongDescription,
    validateLongDescription,
    valueShortDescription,
    validateShortDescription,
    language,
    onChangeLongDescription,
    onChangeShortDescription,
    onChangeLanguage,
    refDataState
}) => {
    return (
        <Section id="description" title={title}>
            <Row>
                <Col>
                    <LanguageSwitch
                        id={`${baseId}_language_switch`}
                        name={`${baseId}_languages`}
                        value={language}
                        onChange={onChangeLanguage}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <TextAreaField
                        name="longDescription"
                        label={labelLongdescription}
                        placeholder={placeholderLongdescription}
                        limit={4000}
                        style={{ height: "120px" }}
                        value={valueLongDescription}
                        onChange={onChangeLongDescription}
                        validate={validateLongDescription}
                        required={branding.configuration.profilePage.sctDescriptionMandatory.companyLongDescriptionMandatory}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <TextAreaField
                        name="shortDescription"
                        label={labelShortdescription}
                        placeholder={placeholderShortdescription}
                        limit={300}
                        style={{ height: "120px" }}
                        value={valueShortDescription}
                        onChange={onChangeShortDescription}
                        validate={validateShortDescription}
                        required={branding.configuration.profilePage.sctDescriptionMandatory.companyShortDescriptionMandatory}
                    />
                </Col>
            </Row>
        </Section>
    )
}

export default withReferenceDataState(Description)
